import React from "react";

import { isPlace, Place } from "../../../../application/domain/proc-management";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import {
  SimpleTextAreaInput,
  SimpleTextInput,
} from "../../../molecules/proc-management/form";

type Props = {
  place: Place | Omit<Place, "id">;
  onChange: (path: (string | number)[], value: any) => void;
  disabled: boolean;
};

export const PlaceForm: React.FC<Props> = ({ place, onChange, disabled }) => {
  const { name, address, tel, receptionHours } = place;
  return (
    <div className="columns">
      <div className="column my-3 mx-3">
        <section className="mb-5">
          <h2 className="subtitle">場所情報</h2>

          {isPlace(place) && (
            <div className="field mb-6">
              <FormFieldLabel label="場所ID" />
              <div className="control">
                <input className="input" value={place.id} disabled />
              </div>
            </div>
          )}

          <div className="field mb-6">
            <FormFieldLabel label="名称" required />
            <SimpleTextInput
              onChange={onChange}
              basePath={["name"]}
              value={name}
              disabled={disabled}
            />
          </div>

          <div className="field mb-6">
            <FormFieldLabel label="電話番号" />
            <SimpleTextInput
              onChange={onChange}
              basePath={["tel"]}
              value={tel}
              disabled={disabled}
            />
          </div>

          <div className="field mb-6">
            <FormFieldLabel label="受付時間" />
            <SimpleTextAreaInput
              onChange={onChange}
              basePath={["receptionHours"]}
              value={receptionHours}
              disabled={disabled}
            />
          </div>

          <div className="field mb-6">
            <FormFieldLabel label="住所" />

            <div className="mb-2">
              <FormFieldLabel label="郵便番号" bold={false} required />
              <SimpleTextInput
                onChange={onChange}
                basePath={["address", "postalCode"]}
                value={address?.postalCode}
                disabled={disabled}
              />
            </div>

            <div className="mb-2">
              <FormFieldLabel
                label="住所 - 丁目番地号より前まで"
                bold={false}
                required
              />
              <SimpleTextInput
                onChange={onChange}
                basePath={["address", "address1"]}
                value={address?.address1}
                disabled={disabled}
              />
            </div>

            <div className="mb-2">
              <FormFieldLabel label="住所 - 丁目番地号" bold={false} required />
              <SimpleTextInput
                onChange={onChange}
                basePath={["address", "address2"]}
                value={address?.address2}
                disabled={disabled}
              />
            </div>

            <div className="mb-2">
              <FormFieldLabel
                label="住所 - ビル名部屋番号会社名等"
                bold={false}
              />
              <SimpleTextInput
                onChange={onChange}
                basePath={["address", "address3"]}
                value={address?.address3}
                disabled={disabled}
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PlaceForm;
